<script>
import * as d3 from 'd3'

export default {
  name: 'BarChart',
  props: {
    xKey: {
      type: String,
      required: true,
    },
    yKey: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    svgWidth: 0,
    svgHeight: 300,
    redrawToggle: true,
  }),
  mounted() {
    var svgContainer = this.$refs['svgContainer']
    this.svgHeight = 300
    this.svgWidth = svgContainer.offsetWidth

    var margin = { top: 20, right: 0, bottom: 30, left: 70 }

    var svg = d3
      .create('svg')
      .attr('viewBox', [0, 0, this.svgWidth, this.svgHeight])

    var x = d3
      .scaleBand()
      .domain(d3.range(this.data.length))
      .range([margin.left, this.svgWidth - margin.right])
      .padding(0.1)

    var y = d3
      .scaleLinear()
      .domain([0, d3.max(this.data, d => d.value)])
      .nice()
      .range([this.svgHeight - margin.bottom, margin.top])

    svg
      .append('g')
      .attr('fill', '#00bcd4')
      .selectAll('rect')
      .data(this.data)
      .join('rect')
      .attr('x', (d, i) => x(i))
      .attr('y', d => y(d.value))
      .attr('height', d => y(0) - y(d.value))
      .attr('width', x.bandwidth())

    var xAxis = g =>
      g
        .attr('transform', `translate(0,${this.svgHeight - margin.bottom})`)
        .call(
          d3
            .axisBottom(x)
            .tickFormat(i => (i % 2 === 1 ? this.data[i][this.xKey] : ''))
            .tickSizeOuter(0)
        )

    svg.append('g').call(xAxis)

    var yAxis = g =>
      g
        .attr('transform', `translate(${margin.left},0)`)
        .call(d3.axisLeft(y))
        .call(g => g.select('.domain').remove())

    svg
      .append('g')
      .call(yAxis)
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('fill', 'black')
      .attr('y', -margin.left / 2.0 - 15)
      .attr('x', -(this.svgHeight / 2.0 - margin.top - margin.bottom))
      .attr('dy', '.5em')
      .style('text-anchor', 'end')
      .text('Count of Requests')

    svgContainer.append(svg.node())
  },
}
</script>

<template>
  <div ref="svgContainer" class="svgContainer" align="center"></div>
</template>

<style scoped>
.barPositive {
  fill: steelblue;
  transition: r 0.2s ease-in-out;
}

.barPositive:hover {
  fill: brown;
}

.svgContainer {
  position: relative;
  display: inline-block;
  width: 100%;
  padding-bottom: 1%;
  overflow: hidden;
  vertical-align: top;
}
</style>
